import {
    CustomPIXIComponent,
} from "react-pixi-fiber";

interface IProps {
    duration: number,
}

export const Background = CustomPIXIComponent<IProps, PIXI.Graphics>({
    customApplyProps: (instance, _2, props) => {
      const {
        duration
      } = props;

      instance.beginFill(0xFFFFFF);
      instance.drawRect(0, 0, 1, 600);
      instance.endFill();
  
      instance.scale.set(duration, 1);
    },
    customDisplayObject: () => new PIXI.Graphics(),
}, 'Background');

export default Background;



// WEBPACK FOOTER //
// ./src/components/Player/Background.tsx